import React, { useState, useEffect } from 'react';
import { Select, message } from 'antd'
import axios from "axios"

const { Option } = Select 

/**
 * @const SelectRazonSocial
 * @description Select para las razones sociales registradas en el sistema
 */
const SelectRazonSocial = (props) => {

    const { 
        value, 
        onChange = () => {}, 
        placeholder = "Seleccione la razón social", 
        onSelect = () => {}, 
        disabled = false, 
        className = "", 
        params = {}, 
        bordered, 
        allowClear = true, 
        onClear = () => {},
        labelInValue
    } = props

    const [ razonesSociales, setRazonesSociales ] = useState({
        itemsList: [],
        currentPage: 1,
        limit: 50,
        total: 0,
        search: null,
    })


    /**
     * @const getRazonesSociales
     * @description Obtiene las razones sociales
     */
    const getRazonesSociales = ({
        currentPage, 
        limit, 
        search, 
    } = razonesSociales) => {

        axios.get('/razones-sociales', {
            params: {
                page: currentPage,
                limit,
                search,
                ...params,
            },
            headers: { Authorization: sessionStorage.getItem('token') }
        }).then(({ data }) => {
            console.log('data',data);
            setRazonesSociales(data.data)
        }).catch(error => {
            console.log("ERR, error",error)
            message.error(error?.response?.data?.message ?? 'Error al obtener las razones sociales')
        })
    }

    //componentDidMount
    useEffect(() => {
        getRazonesSociales()
    }, [])

    


    return (
        <Select
            bordered={bordered}
            className={className}
            disabled={disabled}
            placeholder={placeholder}
            allowClear={allowClear}
            showSearch
            filterOption={false}
            labelInValue
            onSearch={(search)=> getRazonesSociales({search})}
            onSelect={(razonSocial, option)=> {
                const data = {
                    _id: razonSocial.value,
                    razon_social: option.razon_social.razon_social,
                    rfc: option.razon_social.rfc,
                    regimen_fiscal: option.razon_social.regimen_fiscal
                }
                if(!labelInValue){
                    onChange(razonSocial.value)
                    onSelect(data)
                } else {
                    onChange(razonSocial)
                    onSelect(data)
                }
            }}
            value={value}
            onClear={()=>{
                onClear()
                onChange(undefined)
                onSelect(undefined)
            }}
        >
            {
                razonesSociales?.itemsList?.map((rs) => 
                    <Option value={rs._id} key={rs._id} razon_social={rs}>{rs.razon_social ?? ""} {rs.rfc ? `(${rs.rfc})` : ""}</Option>
                )
            }
        </Select>
    );
}



export default SelectRazonSocial;
